<div class="booking-navbar">
  <header class="booking-header">
    <nav class="booking-nav">
      <!-- Logo y marca -->
      <div class="nav-brand">
        <a routerLink="/" class="brand-link">
          <span class="brand-text">Eco-Turismo</span>
        </a>
      </div>

      <!-- Navegación principal -->
      <div class="nav-main">
        <div class="nav-categories">
          <a routerLink="/" class="nav-category">
            <svg class="category-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </svg>
            Inicio
          </a>
        </div>
      </div>

      <!-- Botón menú móvil -->
      <div class="mobile-toggle">
        <button (click)="toggleMobileMenu()" class="mobile-menu-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
          </svg>
        </button>
      </div>
    </nav>

    <!-- Menú móvil -->
    <div [class.show]="mobileMenuOpen" class="mobile-menu">
      <div class="mobile-menu-content">
        <div class="mobile-header">
          <span class="mobile-brand">Eco-Turismo</span>
          <button (click)="toggleMobileMenu()" class="mobile-close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div>
        <div class="mobile-categories">
          <a routerLink="/" class="mobile-category">Inicio</a>
        </div>
      </div>
    </div>
  </header>
</div>